import { createApp } from 'vue'
import store from './store'

import vhFixForIOS from './modules/vh-fix-for-ios'
import vueAppInitiator from './modules/vue-app-initiator'
import vueUIInitiator from './modules/vue-ui-initiator'
import showMoreLinks from './modules/show-more-links'
import expandedList from './modules/expanded-list'
import modalVideo from './modules/modal-video'
import modalGallery from './modules/modal-gallery'
import mainNav from './modules/main-nav'
import marquee from './modules/marquee'
import searchInputs from './modules/search-inputs'
import newsMainSearch from './modules/news-main-search'
import vueInfinityNews from './modules/vue-infinity-news'
import stickyNav from './modules/sticky-nav'
import anchorLinks from './modules/anchor-links'
import maxHeight from './modules/max-height'
import macDevice from './modules/mac-device'
import fixPosition from './modules/fix-position'

import HousePriceDynamics from './charts/HousePriceDynamics' // Не найден
import FooterNav from './vue-components/FooterNav'
import MyModal from './vue-components/ui/MyModal' // Для согласия обработки персональных данных
import DatepickerSelect from './vue-components/DatepickerSelect' // Много
import MySelect from './vue-components/MySelect' // 6 страниц и компонентов
import MyAccordion from './vue-components/MyAccordion' // 8 страниц и компонентов
import NavSelect from './vue-components/NavSelect' // Используется в меню всех страниц
import InfoBlock from './vue-components/InfoBlock' // Главная страница
import TooltipComponent from './vue-components/TooltipComponent' // Много где используется
import TabsTable from './analytics/all-study/components/TabsTable' // Компонент дублируется в хэдере и на главной
import AnalyticsInfoBlock from './analytics/all-study/components/InfoBlock' // Компонент дублируется на главной
import Analysis from './analytics/mortgage/components/Analysis' // Компонент дублируется на главной
import CollateralPropertyForm from './vue-components/CollateralPropertyForm'
import CollateralPropertyList from './vue-components/CollateralPropertyList'
import CollateralItemPage from './vue-components/CollateralItemPage'
import NewsMainPage from './vue-components/news/NewsMainPage'
import NewsDetailPage from './vue-components/news/NewsDetailPage'
import MediaLibraryDetail from './vue-components/news/MediaLibraryDetail'
import TelegramBlock from './vue-components/TelegramBlock'
import TopTwentyBusinesses from './vue-components/TopTwentyBusinesses'
import HousingConstructionReportDetail from './vue-components/HousingConstructionReportDetail'

document.addEventListener('DOMContentLoaded', () => {
    vhFixForIOS();
    modalVideo();
    modalGallery();
    marquee();
    searchInputs();
    newsMainSearch();
    setTimeout(() => {
        stickyNav();
    }, 0);

    const vueApps = [
        {
            el: '#footer-nav',
            components: {
                FooterNav
            }
        }
    ];

    vueAppInitiator(vueApps);
    vueUIInitiator('js--select-init', MySelect, 'my-select');
    vueUIInitiator('js--accordion-init', MyAccordion, 'my-accordion');
    vueUIInitiator('js--datepicker-init', DatepickerSelect, 'datepicker-select');
    vueUIInitiator('js--house-price-dynamics-init', HousePriceDynamics, 'house-price-dynamics');
    vueUIInitiator('js--nav-select-init', NavSelect, 'nav-select');
    vueUIInitiator('js--info-block', InfoBlock, 'info-block');
    vueUIInitiator('js--tooltip', TooltipComponent, 'tooltip-component');
    vueInfinityNews();
    vueUIInitiator('js--a-indicator-table', TabsTable, 'tabs-table');
    vueUIInitiator('js--a-analysis', Analysis, 'analysis');
    vueUIInitiator('js--my-modal', MyModal, 'my-modal');
    vueUIInitiator('js--collateral-property-form', CollateralPropertyForm, 'collateral-property-form');
    vueUIInitiator('js--collateral-property-list', CollateralPropertyList, 'collateral-property-list');
    vueUIInitiator('js--collateral-item-page', CollateralItemPage, 'collateral-item-page');
    vueUIInitiator('js--news-main-page', NewsMainPage, 'news-main-page');
    vueUIInitiator('js--news-detail-page', NewsDetailPage, 'news-detail-page');
    vueUIInitiator('js--media-library-detail', MediaLibraryDetail, 'media-library-detail');
    vueUIInitiator('js--telegram-block', TelegramBlock, 'telegram-block');
    vueUIInitiator('js--top-twenty-businesses', TopTwentyBusinesses, 'top-twenty-businesses');
    vueUIInitiator('js--housing-construction-report-detail', HousingConstructionReportDetail, 'housing-construction-report-detail');
});

window.addEventListener('load', () => {
    anchorLinks();
    showMoreLinks();
    expandedList();
    mainNav();
    maxHeight();
    macDevice();
    fixPosition();

    let indicatorBlock = document.getElementById('js--a-indicator-info-block');
    if (indicatorBlock) {
        createApp(AnalyticsInfoBlock).use(store).mount('#js--a-indicator-info-block');
    }
});
